<template>
  <div class="relative flex-1 px-4 sm:px-6">
    <div class="space-y-4 options">
      <div class="flex justify-between items-start">
        <h2 class="text-base font-semibold tracking-wide md:text-xl text-gray-50">Lighting</h2>
        <div @click.prevent="$emit('close')"
          class="px-2 py-1 -mx-2 -my-2 text-white rounded-full cursor-pointer hover:bg-gray-100 hover:text-gray-700 hover:ring-white">
          <i class=" fas fa-chevron-down"></i>
        </div>
      </div>

        <div class="flex justify-between gap-8 mt-3">
          <template v-for="light in lights">
          <button type="button"
            @click.prevent="$emit('change', { key: 'light', value: light.id })"
            class="inline-flex items-center justify-center flex-1 px-4 py-2 text-sm font-medium border border-transparent rounded-md ring-2 ring-transparent"
            :class="[
                state.light === light.id
                  ? 'text-white bg-yellow-400 '
                  : 'text-yellow-700 bg-yellow-200 hover:ring-yellow-500',
              ]">
            {{ light.title }}
          </button>
        </template>
        </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    state: {
      type: Object,
      default: null
    }
  },

  data () {
    return  {
      lights: [
        {
            title: 'Setup 1',
            id: 'light_1',
        },
        {
            title: 'Setup 2',
            id: 'light_2',
        },
        {
            title: 'Setup 3',
            id: 'light_3',
        }
      ]
    }
  }
}
</script>
